import { COOKIE_CHECK_LIST } from "./cookie-policy.data";
import { PAYMENT_PROMOTION_CHECK_LIST } from "./payment-and-promotion.data";
import { PRIVACY_CHECK_LIST } from "./privacy-policy.data";
import { TERMS_AND_CONDITIONS_CHECK_LIST } from "./terms-and-conditions.data";
import { environment } from "src/environments/environment";
export const email = 'admin@email.in.th'
const tel = '08x-xxx-xxxx'
const address = 'xx/xxx ซอยสุคนธสวัสดิ์ 19 แขวงลาดพร้าว เขตลาดพร้าว กทม'

export function returnCheckList({ file_data, check_list_id, bullet = 'dot', index_start = 0, index_end }: {
    file_data: typeof TERMS_AND_CONDITIONS_CHECK_LIST | typeof PRIVACY_CHECK_LIST | typeof PAYMENT_PROMOTION_CHECK_LIST | typeof COOKIE_CHECK_LIST;
    check_list_id: number;
    bullet?: 'dot' | 'number';
    index_start?: number
    index_end?: number
}): string {
    const check_list = file_data?.find(item => item.id === check_list_id)!.check_list || []
    if (!index_end) {
        index_end = check_list.length - 1
    }
    const data = { check_list, bullet, index_start, index_end }

    let innerHtml = returnDefaultList(data)
    return innerHtml;
}

export function returnDefaultList({
    check_list,
    bullet = 'dot',
    index_start = 0,
    index_end = check_list.length - 1
}: {
    check_list: string[];
    bullet?: 'dot' | 'number';
    index_start?: number
    index_end?: number
}): string {
    let innerHtml = check_list ? `
    ${bullet === 'dot' ? `<ul class="mb-0">` : `<ol class="mb-0"    >`}
      ${check_list.map((item, index) =>
        (index >= index_start && index <= index_end) ?
            `<li>${item}</li>` : '',).join('')}
    ${bullet === 'dot' ? `</ul>` : `</ol>`}` : ''
    return innerHtml
}

export function stringContact(): string {
    return `
    <p class="mb-0 fw-bold fs-6 mt-1">${environment.appName}</p>
    <p class="mb-0">อีเมล: ${email}</p>
    <p class="mb-0">โทรศัพท์: ${tel}</p>
    <p class="mb-0">ที่อยู่: ${address}</p>
    `
}